import $ from '@vaersaagod/tools/Dom';
import Viewport from '@vaersaagod/tools/Viewport';
import Flickity from 'flickity';

export default (el, props) => {
    const $el = $(el);
    const $wrap = $el.find('[data-slideshow-wrapper]');
    const $slides = $el.find('[data-slideshow-slide]');
    const $btns = $el.find('[data-slideshow-nav]');
    const autoplay = props.autoplay;
    const interval = props.interval;
    
    let flkty = null;

    const onResize = e => {
        e.preventDefault();
        
    };

    const onNavClick = e => {
        e.preventDefault();
        const $trigger = $(e.triggerTarget);
        const direction = $trigger.length > 0 && $trigger.hasClass('-prev') ? 'prev' : 'next';
        
        if (flkty) {
            if (direction === 'next') {
                flkty.next();
            }
            if (direction === 'prev') {
                flkty.previous();
            }
        }
        
    };

    const init = () => {
        $btns.on('click', onNavClick);
        
        $slides.css({ display: 'block' });
        
        flkty = new Flickity($wrap.get(0), {
            cellSelector: '[data-slideshow-slide]',
            contain: true,
            wrapAround: true,
            autoPlay: autoplay ? interval : false,
            pageDots: false,
            prevNextButtons: false,
            draggable: true,
            dragThreshold: 10,
            setGallerySize: true,
            percentPosition: false,
            accessibility: false,
            freeScroll: false,
            cellAlign: 'left'
        });
        
        Viewport.on('resize', onResize);
    };

    const destroy = () => {
        $btns.off('click', onNavClick);
        Viewport.off('resize', onResize);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/HeroSlideshow.js